<template>
  <b-card header-tag="header" class="contact-basket">
    <div class="border-bottom d-flex justify-content-between align-items-center">
      <h4>
        <template v-if="isRecruiter">Selected Candidates</template>
        <template v-else>Selected Contacts</template>
      </h4>
      <span class="flex-fill"/>
      <a class="mb-2" v-if="selectedContactIDs.length > 0 && $listeners.clearContacts"
        href="#" @click.prevent="$emit('clearContacts')">Clear</a>
    </div>

    <template v-if="selectedContactIDs.length > 0">
      <basket-item v-for="contactID in selectedContactIDs" :key="contactID"
        :contact="selectedContactData[contactID]" v-on="basketItemListeners(contactID)"/>
    </template>
    <b-row class="no-contacts" v-else>
      <div class="plus-circle">
        <font-awesome-icon icon="plus" class="secondary-color" />
      </div>
      <div class="text" v-if="isRecruiter">
        <b>Want to get referrals?</b>
        <p>Search below and then ask your employees to make a referral introduction...</p>
      </div>
      <div class="text" v-if="!isRecruiter">
        <b>Want to add your own?</b>
        <p>Search your contacts below or upload some more...</p>
      </div>
    </b-row>

    <b-btn variant="primary" @click="$emit('submit')" v-if="isRecruiter" :disabled="selectedContactIDs.length === 0">Request referral</b-btn>
    <b-btn variant="primary" @click="$emit('submit')" v-if="!isRecruiter" :disabled="selectedContactIDs.length === 0" data-tour="refer-your-contacts">Refer your contacts</b-btn>
  </b-card>
</template>

<script>
import BasketItem from '@/components/contacts/basketItem';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'ContactsBasket',
  components: {
    BasketItem,
    FontAwesomeIcon,
  },
  props: {
    selectedContactIDs: {
      type: Array,
      default: () => ([]),
    },
    selectedContactData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapRoot([ 'isRecruiter' ]),

  },
  methods: {
    basketItemListeners(contactID) {
      const listeners = {};

      if (this.$listeners.removeContact) {
        listeners.removeContact = () => this.$emit('removeContact', contactID);
      }

      return listeners;
    },
  },
};
</script>

<style lang="scss">
@import './../../scss/variables';

.contact-basket {
  &.sticky-top {
    z-index: 100;
  }
  .jobTitle {
    font-weight: bold;
  }
  .company {
    font-size: $small-font-size;
  }
  .contact-list {
    padding-top: 1rem;
  }
  .contact {
    padding-bottom: 0.7rem;
    padding-top: 0.7rem;
    img {
      margin-right: 1rem;
      height: 3em;
      width: 3em;
    }
  }
  .no-contacts {
    padding-top: 3em;
    padding-bottom  : 3em;
    .text {
      padding-top: 2rem;
      text-align: center;
      font-weight: 500;
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
  .plus-circle {
    margin: 0 auto;
    width: 60px;
    height: 60px;
    opacity: 0.33;
    border-radius: 100%;
    line-height: 60px;
    text-align: center;
    .svg-inline--fa {
      margin-top: inherit;
      vertical-align: middle;
      height:30px;
      width: 30px;
    }
    background-color: #dadada;
  }
  .btn {

    margin: 0 auto;
  }
  .btn-primary {
    margin-top: 1em;
    width: 100%;
  }
  .svg-inline--fa {
    margin-top: 0.5em;
    height:20px;
    width: 20px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/basket.vue